'use strict';
import angular from 'angular';
import './base/flickity.components';

angular.module('core.flickity', [
    //'core.flickity.constants',
    'core.flickity.components',
]);